import React from 'react';
import { TextField } from '@material-ui/core';
import { Control, Controller } from 'react-hook-form';
import { AnyEmptyQuestion } from '../../../../../../types';
import { StyledAnswerRow } from '../../styles';
import { Close, Warning } from '@material-ui/icons';
import styled from 'styled-components';
import { colors } from '../../../../../../../../healtheraComponents';

interface Props {
  control: Control<AnyEmptyQuestion>;
  onRemove: () => void;
  isBlocking: boolean;
  onToggleIsBlocking: () => void;
  /**
   * False where the flag can only be cleared, not added — on an information screen with
   * nothing blocking yet. The click is refused there, so the control says so rather than
   * looking live and doing nothing.
   */
  canToggleIsBlocking: boolean;
  index: number;
}

const AnswerEditor = ({ control, index, onRemove, isBlocking, onToggleIsBlocking, canToggleIsBlocking }: Props) => (
  <StyledAnswerRow>
    <Controller
      name={`answers.${index}.value`}
      control={control}
      render={({ field: { onChange, ref, ...restField } }) => (
        <TextField
          inputRef={ref}
          {...restField}
          fullWidth
          placeholder="Answer"
          onChange={e => {
            onChange(e.target.value);
          }}
        />
      )}
    />
    {index !== 0 && <Close onClick={onRemove} />}
    {
      <StyledWarning
        titleAccess="Blocking answer"
        aria-disabled={!canToggleIsBlocking}
        $isRed={isBlocking}
        $isInteractive={canToggleIsBlocking}
        onClick={() => onToggleIsBlocking()}
      />
    }
  </StyledAnswerRow>
);

const StyledWarning = styled(Warning)<{
  $isRed: boolean;
  $isInteractive: boolean;
}>`
  color: ${({ $isRed }) => ($isRed ? colors.HEALTHERA_RED : colors.GRAY )};
  cursor: ${({ $isInteractive }) => ($isInteractive ? 'pointer' : 'default')};
  opacity: ${({ $isInteractive }) => ($isInteractive ? 1 : 0.4)};
`;

export default AnswerEditor;
